import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
export var shouldShowPromotedBadge = function(is_promoted, promoted_by) {
    if (!is_promoted) {
        return false;
    }
    return promoted_by.includes(IProduct.PromotedType.ADS);
};
